import {
  createActionGroup,
  createFeature,
  createReducer,
  on,
  props,
} from '@ngrx/store';
import { MenuItemName } from '../menu.config';

export const PageActions = createActionGroup({
  source: 'Page',
  events: {
    'Go To Page': props<{ page: string }>(),
    'Page Visited': props<{ page: string; url: string }>(),
    'Set Active Menu': props<{ activeMenu: MenuItemName }>(),
  },
});

interface PageState {
  pages: Map<string, string>;
  activeMenu: MenuItemName | null;
}

const initialPageState: PageState = {
  pages: new Map(),
  activeMenu: null,
};

function updatePageUrl(state: PageState, page: string, url: string): PageState {
  const pages = new Map(state.pages);
  pages.set(page, url);
  return { ...state, pages };
}

export const pageFeature = createFeature({
  name: 'Page',
  reducer: createReducer(
    initialPageState,
    on(PageActions.pageVisited, (state, action) =>
      updatePageUrl(state, action.page, action.url),
    ),
    on(PageActions.setActiveMenu, (state, action) => ({
      ...state,
      activeMenu: action.activeMenu,
    })),
  ),
});
